<template>
  <div class="q-dnd">
    <div class="ma-auto" elevation="0">
      <div class="p-h-3 inline-words">
        <div class="q-dnd-texts">
          <div>
            <span v-for="(item, key) in variants" :key="key">
              <span v-if="item.type == 'simple'" v-html="$options.filters.breakSpace(item.value)"></span>
              <span v-if="item.type == 'answer'" >
                <draggable     
                    class="list-group" 
                    :list="item.list"
                    :group="{name: 'words'}"
                    v-bind="dragOptions"
                    @change="changeDraggble"
                    >
                  <div class="list-group-item"  v-for="(element, key) in item.list" :key="key">
                    {{ element.value }}
                  </div>
                </draggable>
              </span>
            </span>
          </div>
        </div>
        <div class="q-dnd-items">
          <div class="text-x5">Варианты ответов:</div>
          <draggable 
            class="draggable-wrapper"
            :list="answers_values" 
            :group="{name: 'words'}"
            tag="ul"
            v-bind="dragOptions"
            >
            <transition-group type="transition" name="flip-list" class="list-group">
              <li class="list-group-item" v-for="(element) in answers_values"  :key="element.id">
                {{ element.value }}
              </li>
            </transition-group>
          </draggable>
        </div>
      

      </div>

      <div class="ta-center m-t-10 btn-content">
        <v-btn :loading="loading" @click="answer" class="mt-8" large color="info">
          Ответить на вопрос
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>


/* 
 REDO 
 Переписать
*/
export default {
  components: {
    draggable: () => import("vuedraggable"),
  },
  props: {
    data: Object,
  },
  watch:{

  },
  created() {
    this.variants = this.data.metadata.variants
    let cnt = 0
    this.variants.forEach((el, i)=>{
      if(el.type == 'answer'){
        let item = {id: `${cnt}`, value: el.value}
        el.list = []
        this.answers_values.push(item)
        this.answers_all.push(item)
        if(el.variants){
          for (let u = 0; u < el.variants.length; u++) {
            this.answers_values.push({id: `${cnt}-${u}`, value: el.variants[u]})
          }
        }
        el.id = cnt++
      }
    })
  },
  mounted(){
    this.answers_values = this.shuffle(this.answers_values)
  },
  data() {
    return {
      variants: [],
      answers_values: [],
      answers_all: [],
      input_values: [],
      loading: false
    }
  },
  computed: {
    statusValid(){
      return this.input_values.length == this.answers_all.length
    },
    dragOptions() {
      return {
        animation: 200,
        swap: true,
        ghostClass: "ghost",
      };
    }
  },
  methods: {
    async answer() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500);
      return
      let params = {
        question_id: this.data['id']
      }
      let answers_data = this.input_values.map(e=>{return e.value})
      params.answers = answers_data
      let answer = await setAnswers(this, this.work_id, this.data['id'], params);
      if (answer && answer.data) {
        this.$emit('input', answer.data);
      }
       this.loading = false;
    },
    changeDraggble(a, b){
      /* redo */
      if(Object.keys(a)[0] == 'added'){
        this.variants.forEach((di)=>{
          if(di.type != "answer") return
          if(di.list[1]){
            di.list.forEach((e, i)=>{
              if(e.id != a.added.element.id){
                this.answers_values.push(e)
                di.list.splice(i, 1)
              }
            })
          }
        })
      }
      let arr = []
      this.variants.forEach(e=>{
        if(e.type != "answer") return;
          e.list.forEach((e)=>{
            arr.push(e)
          })
      })
      this.input_values = arr
    },
    shuffle(array) {
      let currentIndex = array.length,  randomIndex;
      while (currentIndex != 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }
      return array;
    }
  },
}
</script>
